import Logo from "./Logo";

const links = [
    { label: "Inicio", href: "#inicio" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Precios", href: "#precios" },
    { label: "Productos", href: "#productos" },
    { label: "Contacto", href: "#contacto" },
];

export default function Footer() {
    const goTo = (href) => (e) => {
        e.preventDefault();
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#FAFAF8] border-t border-[#e6e2db] pt-14 pb-8"
        >
            <div className="max-w-6xl mx-auto px-6 lg:px-12 text-center">
                <div className="flex justify-center">
                    <Logo size="md" />
                </div>
                <p className="font-display italic text-xl sm:text-2xl text-[#1C1A18] mt-8 max-w-lg mx-auto">
                    Capturando lo que el tiempo no puede borrar.
                </p>

                <nav className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={goTo(l.href)}
                            data-testid={`footer-link-${l.label.toLowerCase()}`}
                            className="text-[10px] tracking-[0.32em] uppercase text-[#6b665f] hover:text-[#1C1A18] link-underline"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="mt-12 pt-8 border-t border-[#e6e2db] flex flex-col items-center gap-3">
                    <p className="text-[10px] tracking-[0.32em] uppercase text-[#6b665f]">
                        Fotógrafa en Sestao, Portugalete, Barakaldo y Bilbao ·
                        País Vasco · España · © 2025 Silvia García Fotografía
                    </p>
                    <a
                        href="/privacidad"
                        data-testid="footer-privacy-link"
                        className="text-[10px] tracking-[0.32em] uppercase text-[#9a958c] hover:text-[#1C1A18] link-underline"
                    >
                        Política de privacidad y cookies
                    </a>
                    <p
                        data-testid="tapdigital-credit"
                        className="text-[11px] text-[#9a958c] font-light tracking-wide"
                        style={{ fontFamily: "Inter, Jost, system-ui, sans-serif" }}
                    >
                        Digital experience by{" "}
                        <a
                            href="https://tapdigital.es"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="tapdigital-link"
                            className="tapdigital-link font-medium"
                        >
                            TapDigital
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
